// extracted by mini-css-extract-plugin
export default {"header":"RecentDevicesView_header__WiS64","referral":"RecentDevicesView_referral__FFnLy","referralText":"RecentDevicesView_referralText__caN7u"};